import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCropMetadataForFrame } from 'reducers/Refinements';

export default function useCropMetadata({
	assetId,
	frameWidth,
	frameHeight,
	skip = false,
}) {
	const dispatch = useDispatch();
	const cropMetadataDictionary = useSelector(state => state.refinements.cropMetadataDictionary);
	const cropMetadata = cropMetadataDictionary[`${assetId}_${frameWidth}_${frameHeight}`];
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	useEffect(() => {
		// Do nothing if skip is set to true or there is no crop metadata
		if (!skip && !cropMetadata) {
			// If there is no crop metadata send a request to adStudion to get it
			setIsLoading(true);
			dispatch(getCropMetadataForFrame(assetId, frameWidth, frameHeight)).then((response) => {
				if (response?.error) {
					setError("Failed to get crop metadata");
				}
				setIsLoading(false);
			});
		}
	}, [skip, cropMetadata, assetId, frameWidth, frameHeight]);


	return { isLoading, cropMetadata, error };
}
